<template>
  <div id="payment-voucher-edit" class="group-setup">
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>

    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-form v-if="!loading">
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-card class="pa-5" flat>
            <HeaderDividerBlock headerText="Edit Payment Voucher">
            </HeaderDividerBlock>
            <v-row>
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">PO Number</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.po_id"
                  required
                  clearable
                  placeholder="Select PO Number"
                  :items="purchaseOrders"
                  item-text="po_number"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Branch Code</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.branch_id"
                  required
                  clearable
                  placeholder="Select Branch"
                  :items="branches"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Payment Amount</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.amount"
                  required
                  clearable
                  placeholder="Enter Amount"
                  type="number"
                ></v-text-field>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Payment Type</p>
                </v-col>
                <v-select
                  outlined
                  dense
                  v-model="form.payment_type"
                  :items="paymentTypes"
                  required
                  clearable
                  placeholder="Select Payment Type"
                ></v-select>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Status</p>
                </v-col>
                <v-select
                  outlined
                  dense
                  v-model="form.status"
                  :items="statusOptions"
                  required
                  clearable
                  placeholder="Select Status"
                  disabled
                ></v-select>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Financial Year</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.financial_year_id"
                  required
                  clearable
                  placeholder="Select Financial Year"
                  :items="financialyears"
                  item-text="year"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Attach Invoice</p>
                </v-col>
                <v-file-input
                  outlined
                  dense
                  v-model="form.path"
                  accept=".pdf, .jpg, .png, .jpeg, .docx"
                  placeholder="Upload Invoice"
                  clearable
                  hint="Allowed file types: .pdf, .jpg, .png, .jpeg, .docx"
                ></v-file-input>
              </v-col>

              <v-col cols="12" sm="12">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Remarks</p>
                </v-col>
                <v-text-field
                  placeholder="Enter Remarks"
                  outlined
                  dense
                  v-model="form.remarks"
                  required
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card-actions class="mt-10">
              <v-row>
                <v-col cols="12" md="10" xs="6"></v-col>
                <v-col cols="12" md="2" xs="6">
                  <v-btn
                    v-if="hasPermission('payment_voucher.edit')"
                    large
                    color="#00B3FF"
                    dark
                    depressed
                    block
                    @click="update"
                  >
                    Update Voucher
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="clossSnackbar"
    />
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { PaymentVoucherService } from "@/services/paymentVoucher-service.js";
import { checkError } from "@/config/errors.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "EditPaymentVoucher",
  components: {
    Alert,
    Snackbars,
    HeaderDividerBlock,
  },
  props: {
    voucherId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    form: {
      po_id: "",
      branch_id: "",
      financial_year_id: "",
      amount: 0.0,
      payment_type: "",
      status: "",
      remarks: "",
      path: "",
    },
    purchaseOrders: [],
    branches: [],
    financialyears: [],
    paymentTypes: ["bank", "cash", "cheque"],
    statusOptions: ["post", "post and save"],
    loadingPurchaseOrders: false,
    loadingBranches: false,
    loadingYears: false,
  }),
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },
  created() {
    this.fetchPurchaseOrders();
    this.fetchBranches();
    this.fetchFinanacialYears();
    this.loadVoucherData();
  },
  methods: {
    async loadVoucherData() {
      try {
        this.loading = true;
        const response = await PaymentVoucherService.getVoucherByUUId(
          this.$route.params.uuid
        );
        if (response) {
          const voucherData = response.data;
          this.form.po_id = voucherData.po_id;
          this.form.branch_id = voucherData.branch_id;
          this.form.financial_year_id = voucherData.financial_year_id;
          this.form.amount = voucherData.amount;
          this.form.payment_type = voucherData.payment_type;
          this.form.status = voucherData.status;
          this.form.remarks = voucherData.remarks;
          this.form.path = voucherData.path;
        }
      } catch (error) {
        console.error(error);
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loading = false;
      }
    },

    async update() {
      this.loading = true;
      this.errors = null;
      try {
        const response = await PaymentVoucherService.updatePaymentVoucher(
          this.$route.params.uuid,
          this.form
        );
        this.succesMsg = response.message;
        this.snackbar = true;
      } catch (error) {
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      }
      this.loading = false;
    },

    async fetchPurchaseOrders() {
      try {
        this.loadingPurchaseOrders = true;
        const purchaseOrders = await PaymentVoucherService.getAllPurchaseOrders();
        this.purchaseOrders = purchaseOrders.data;
      } catch (error) {
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loadingPurchaseOrders = false;
      }
    },

    async fetchFinanacialYears() {
      try {
        this.loadingYears = true;
        const years = await PaymentVoucherService.getYears();
        this.financialyears = years.data;
      } catch (error) {
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loadingYears = false;
      }
    },

    async fetchBranches() {
      try {
        this.loadingBranches = true;
        const branches = await PaymentVoucherService.getBranches();
        this.branches = branches.data;
      } catch (error) {
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loadingBranches = false;
      }
    },

    clossSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
